import { BrowserRouter, Route, Routes } from "react-router-dom";
import { DataProvider } from "./globalState.js";
import { useSelector } from "react-redux";

import './fonts/FontStyles.css';
import './App.css'
import Logo from "./page/Intro/Logo.jsx";
// import Intro from "./page/Intro/Intro";
// import StoreHome from "./page/store/Home/Home";
import Home from "./page/Home/Home";
import About from "./page/about/About";
// import Projects from "./page/projects/Projects";
import Contact from "./page/contact/Contact";
import Login from "./components/auth/login/Login";
import Register from "./components/auth/register/Register";
import Project from "./components/project/Project";
import NotFound from "./utils/notFound/NotFound.jsx"
import Dashboard from "./components/dashboard/admin/Dashboard.jsx";
import DashHome from "./components/dashboard/admin/pages/dashHome/DashHome.jsx";
// import Orders from "./components/dashboard/admin/pages/orders/Orders.jsx";
import Profile from "./components/dashboard/admin/profile/Profile.jsx";
import Promote from "./components/dashboard/admin/profile/Promote.jsx";
import Users from "./components/dashboard/admin/profile/Users.jsx";
// import Products from "./components/dashboard/admin/pages/products/Products.jsx"
import AddMemberTeam from "./components/dashboard/admin/pages/teamMembers/AddMemberTeam.jsx";
import DeleteTeamMember from "./components/dashboard/admin/pages/teamMembers/DeleteTeamMember.jsx";
import AddProject from "./components/dashboard/admin/pages/projects/AddProject.jsx";
import DeleteProject from "./components/dashboard/admin/pages/projects/DeleteProject.jsx";
import EditProject from "./components/dashboard/admin/pages/projects/EditProject.jsx";
import ResetPassword from "./components/auth/forgetpassword/ResetPassword.jsx";
import AboutDash from "./components/dashboard/admin/pages/aboutUs/AboutDash.jsx";
// import UserDashboard from "./components/dashboard/users/UserDashboard.jsx";
// import UserDashHome from "./components/dashboard/users/UserDashHome.jsx";
// import UserProfile from "./components/dashboard/admin/profile/UserProfile.jsx";
// import UserOrders from "./components/dashboard/admin/pages/orders/UserOrders.jsx";
// import History from "./components/dashboard/admin/pages/history/History.jsx";
// import DetailsHistory from "./components/dashboard/admin/pages/history/DetailsHistory.jsx";
// import Forgetpassword from "./components/auth/forgetpassword/Forgetpassword.jsx";
// import DetailsProduct from "./page/store/products/detailsProduct/DetailsProduct.jsx";
// import AddProduct from "./components/dashboard/admin/pages/products/AddProduct.jsx";
// import EditProduct from "./components/dashboard/admin/pages/products/EditProduct.jsx";
// import DeleteProduct from "./components/dashboard/admin/pages/products/DeleteProduct.jsx";
// import AddCategory from "./components/dashboard/admin/pages/category/AddCategory.jsx";
// import DeleteCategory from "./components/dashboard/admin/pages/category/DeleteCategory.jsx";
// import Cart from "./components/cart/Cart.jsx";
// import Address from "./components/address/Address.jsx";
// import ConfirmInformation from "./components/address/ConfirmInformation.jsx";
// import Payment from "./components/payment/Payment.jsx";


// export const appAddress =  'http://127.0.0.1:5000'
export const appAddress =  'https://api.niadoffice.com'


function App() {

 

  const auth = useSelector(state => state.auth)
  // const {isLogged} = auth
  const {isLogged, isAdmin} = auth

  return (
    <DataProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" class='threejs' element={<Logo />} />
          {/* <Route path="/" element={<Intro />} /> */}
          {/* store */}
          {/* <Route path="/store" element={<StoreHome />} /> */}
          {/* <Route path="/products" element={<Products />} /> */}
          {/* <Route path="/product/:id" element={<DetailsProduct />} /> */}

          {/* site */}
          <Route path="/project" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={isLogged ?  <NotFound /> : <Login /> } />
          <Route path="/register"  element={isLogged ? <NotFound /> : <Register />} />
          <Route path="/reset" element={<ResetPassword />} />
          {/* <Route path="/home" element={<Home />} /> */}
          {/* <Route path="/projects" element={<Projects />} /> */}
          {/* <Route path="/forget" element={<Forgetpassword />} /> */}

          {/* dashboard */}
          <Route path="/dashboard" element={isAdmin ?  <Dashboard /> :  <NotFound />} >
            {
              isAdmin ? <Route index element={<DashHome />} /> : <Route index element={<Home />} />
            }
        </Route>
          {/* <Route path="/dashboard" element={isAdmin ?  <Dashboard /> : isLogged ? <UserDashboard /> :  <NotFound />} /> */}
            {/* {
              isAdmin ? <Route index element={<DashHome />} /> : <Route index element={<UserDashHome />} />
            } */}
          {/* </Route> */}
          <Route path="/profile" element={isAdmin ?  <Profile /> : <NotFound />} />
          <Route path="/users" element={ isAdmin ?  <Users /> : <NotFound />} />
          <Route path="/edit_user/:id" element={isAdmin ? <Promote /> : <NotFound />} />
          {/* <Route path="/history" element={isLogged ? <Orders /> : <NotFound />} /> */}
          {/* <Route path="/history/:id" element={isLogged ? <DetailsHistory /> : <NotFound />} /> */}
          {/* <Route path="/history" element={isAdmin ? <History /> : <NotFound />} /> */}

          {/* <Route path="/userProfile" element={isLogged ?  <UserProfile /> : <NotFound />} /> */}
          {/* <Route path="/Orders" exact element={isLogged ? <UserOrders /> : <NotFound />} /> */}
          {/* <Route path="/Orders/:id" element={isLogged ? <History /> : <NotFound />} /> */}
          {/* <Route path="/cart" element={isLogged ? <Cart /> : <NotFound />} /> */}
          {/* <Route path="/address" element={isLogged ? <Address /> : <NotFound />} /> */}
          {/* <Route path="/ConfInfo" element={isLogged ? <ConfirmInformation /> : <NotFound />} /> */}
          {/* <Route path="/payment" element={isLogged ? <Payment /> : <NotFound />} /> */}



          {/* Projects */}
          <Route path="/projects/:id" element={<Project />} />  
          <Route path="/addProject" element={isAdmin ? <AddProject /> : <NotFound />} />
          <Route path="/editProject" element={isAdmin ? <EditProject /> : <NotFound />} />
          <Route path="/deleteProject" element={isAdmin ? <DeleteProject /> : <NotFound />} />

          {/* category */}
          {/* <Route path="/addCategory" element={isAdmin ? <AddCategory /> : <NotFound />} />
          <Route path="/deleteCategory" element={isAdmin ? <DeleteCategory /> : <NotFound />} /> */}

          {/* Products */}
          {/* <Route path="/addProduct" element={isAdmin ? <AddProduct /> : <NotFound />} />
          <Route path="/editProduct" element={isAdmin ? <EditProduct /> : <NotFound />} />
          <Route path="/deleteProducts" element={isAdmin ? <DeleteProduct /> : <NotFound />} /> */}

          {/* about us */}
          <Route path="/editAbout" element={isAdmin ? <AboutDash /> : <NotFound />} />

          {/* Team Member */}
          <Route path="/addTeam" element={isAdmin ? <AddMemberTeam /> : <NotFound />} />
          <Route path="/deleteTeam" element={isAdmin ? <DeleteTeamMember /> : <NotFound />} />

        </Routes>
      </BrowserRouter>
   </DataProvider>
  )
}

export default App
